import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-loader',
  templateUrl: './dialog-loader.component.html',
  styleUrls: ['./dialog-loader.component.css']
})
export class DialogLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
